<template>
  <van-tabs v-model="curActive">
    <van-tab title="目录" name="目录">
      <el-tree :data="treeData" :props="defaultProps" default-expand-all @node-click="nodeHandle"></el-tree>
    </van-tab>
    <van-tab title="书签" name="书签">
      <ul class="notes">
        <li class="note-line" v-for="mark in localMarks" :key="mark.id" @click="setPage(mark.pageNumber)">
          <div class="text">{{ mark.pageNumber }}</div>
          <div class="right-tip">
            <!-- <div class="page">{{ mark.pageNumber }}</div> -->
            <el-button type="text" size="mini" @click="deleteMark(mark.id)">删除</el-button>
          </div>
        </li>
      </ul>
    </van-tab>
    <van-tab title="笔记" name="笔记">
      <ul class="notes">
        <li class="note-line" v-for="note in localNotes" :key="note.id" @click="setPage(note.pageNumber)">
          <el-popover placement="top-start" title="" width="300" trigger="hover" :content="note.content">
            <div class="text" slot="reference">{{ note.content }}</div></el-popover
          >
          <div class="right-tip">
            <div class="page">{{ note.pageNumber }}</div>
              <el-button type="text" size="mini" slot="reference" @click="deleteNote(note.id)">删除</el-button>
          </div>
        </li>
      </ul></van-tab
    >
  </van-tabs>
</template>

<script>
import Custom from '@/api/custom'
import { getSearchParams } from '@/utils'
import { mapGetters } from 'vuex'
let api = new Custom('structureMetaData')
let apiNote = new Custom('bookNotes')
let apiMark = new Custom('bookMarks')
export default {
  data () {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      sourceId: getSearchParams(window.location.href).sourceId,
      curActive: '目录'
    }
  },
  computed: {
    ...mapGetters(['marks', 'notes']),
    localMarks () {
      return this.marks.filter(item => item.sourceId === this.sourceId)
    },
    localNotes () {
      return this.notes.filter(item => item.sourceId === this.sourceId)
    }
  },
  methods: {
    getCatalog () {
      api
        .getRecords({
          pageIndex: 1,
          pageSize: 999,
          sourceId: this.sourceId
        })
        .then(res => {
          let rows = res.rows
          // this.pages = Number(rows[rows.length - 1].endFileName)
          this.treeData = [
            {
              label: rows[0].type,
              children: [
                {
                  label: rows[0].title,
                  page: rows[0].startFileName
                }
              ]
            }
          ]
          for (let i = 1; i < rows.length; i++) {
            if (rows[i].type === rows[i - 1].type) {
              this.treeData[this.treeData.length - 1].children.push({
                label: rows[i].title || rows[i].type,
                page: rows[i].startFileName
              })
            } else {
              this.treeData.push({
                label: rows[i].type,
                children: [
                  {
                    label: rows[i].title || rows[i].type,
                    page: rows[i].startFileName
                  }
                ]
              })
            }
          }
        })
    },
    nodeHandle (item) {
      let num = Number(item.page)
      this.setPage(num)
    },
    setPage (num) {
      this.$bus.$emit('setPage', Number(num) || 1)
      this.$emit('close')
    },
    getMarks () {
      this.$store.dispatch('getMarks')
    },
    getNotes () {
      this.$store.dispatch('getNotes')
    },
    deleteNote (id) {
      this.$confirm('确认要删除该条记录?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiNote
          .deleteRecord({
            id: id
          })
          .then(() => {
            this.getNotes()
            this.$message.success('已删除笔记!')
          })
      })
    },
    deleteMark (id) {
      this.$confirm('确认要删除该条记录?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiMark
          .deleteRecord({
            id: id
          })
          .then(() => {
            this.getMarks()
            this.$message.success('已删除书签!')
          })
      })
    }
  },
  mounted () {
    this.getCatalog()
  },
  watch: {
    curActive (key) {
      switch (key) {
        case '目录':
          this.getCatalog()
          break
        case '书签':
          this.getMarks()
          break
        case '笔记':
          this.getNotes()
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.notes {
  width: 100%;
  .note-line {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    color: #7a7374;
    cursor: pointer;
    height: 16px;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
    margin-top: 12px;
    .text {
      padding: 0 8px;
      background-color: white;
      max-width: 292px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .right-tip {
      background-color: white;
      display: flex;
      align-items: center;
      .page {
        color: #646464;
        margin-right: 16px;
        .font-size-small;
      }
    }
  }
}
/deep/ .el-tree {
  background-color: rgba(0, 0, 0, 0);
  font-family: "FangZhengKaiTi-GBK";
}
</style>
